var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function PytorchLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsx(Asset, Object.assign({ viewBox: "0 0 21 25" }, restProps, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m15.552 8.947 1.773-1.772c3.967 3.882 3.967 10.297-.085 14.264a10.035 10.035 0 0 1-14.265 0 10.036 10.036 0 0 1 0-14.264L10.15 0v3.545l-.59.675-4.728 4.727c-2.954 2.954-2.954 7.765 0 10.72 2.955 2.954 7.766 2.954 10.72 0 2.954-2.955 2.954-7.766 0-10.72Zm-.422-3.63a1.35 1.35 0 1 1-2.701 0 1.35 1.35 0 0 1 2.7 0Z", fill: "currentColor" }) })));
}
export default PytorchLogomark;
